import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/welcome/components/WelcomeTabs.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js")